import { render, staticRenderFns } from "./LIstGroupDisable.vue?vue&type=template&id=1fa8c7c5&"
import script from "./LIstGroupDisable.vue?vue&type=script&lang=js&"
export * from "./LIstGroupDisable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports